const { makeStyles } = require("@material-ui/core");

const useStyles = makeStyles((theme) => {
  return {
    toolbarButton: {
      marginLeft: theme.spacing(1),
    },
    fab: {
      position: "fixed",
      bottom: theme.spacing(1),
      left: theme.spacing(1),
      zIndex: 9999,
    },
    support: {
      position: "fixed",
      bottom: theme.spacing(1),
    },
    bottomScrollPaper: {
      alignItems: "flex-end",
      position: "fixed",
      // bottom:0,
      left: 50,
      width: '100%',
      // height: window.visualViewport.height,
      justifyContent: 'flex-start',
      [theme.breakpoints.down("xs")]: {
        left: 0,
      },
    },
    paperScrollPaper: {
      margin: theme.spacing(2),
      width: '100%',
      // height: '100%',
      [theme.breakpoints.down("xs")]: {
        margin: 0
      },

    },
    bottomPaperScrollBody: {
      verticalAlign: "bottom",
      // width: '100%',
    },
    chatContainer: {
      height: "75vh",
      [theme.breakpoints.down("xs")]: {
        height: "100%"
      },
    },
    linkAttachment: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
    },
    imageAttach: {
      '& img': {
        // maxWidth: `calc(100vw - ${theme.spacing(15)}px)`,
        width:"100%",
        objectFit: 'contain',
        background: '#f5f5f5',
      }
    },
    hasDivider:{
      borderTop: "1px solid #e0e0e0",
    },
    offsetTop: {
      height: theme.spacing(10)
    },
    chatRoot: {
      zIndex: `${theme.zIndex.modal + 2} !important`,
    }
  };
});

export { useStyles };
